import HCHome from "./index"

export default {
  "/help-center/submit-request": HCHome,
  "/help-center*": HCHome,
}
